<template>
  <div class="md-layout"></div>
</template>

<script>
export default {
  props: ["tour_id"],

  data() {
    return {};
  },

  components: {},

  methods: {},

  watch: {},

  mounted() {}
};
</script>
